import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { object, string } from 'yup';

import { useToast } from 'Component/Alerta';
import BotaoLink from 'Component/BotaoLink';
import Cabecalho from 'Component/Cabecalho';
import Form, { Botao, Campo } from 'Component/Form';
import Icone from 'Component/Icone';
import LayoutDefault from 'Component/Layout';
import Usuario from 'Interface/Usuarios';
import { useEditarUsuarioMutation, useRecuperarUsuarioQuery } from 'Service';

const regras = object({
    senha: string().required('Obrigatório'),
});

const AlterarSenha = (): React.ReactElement =>
{
    const navegacao = useNavigate();
    const toast = useToast();
    const { id = 0 } = useParams();
    const { data, isLoading } = useRecuperarUsuarioQuery(id);
    const [ editarUsuario ] = useEditarUsuarioMutation();

    const enviar = async (dados: Usuario): Promise<void> =>
    {
        try {
            await editarUsuario(dados).unwrap();

            toast({ conteudo: 'Senha alterada com sucesso!', tema: 'success' });

            navegacao(`/usuarios/editar/${id}`);
        } catch (error) {
            toast({
                titulo: 'Erro ao editar',
                conteudo: 'Verifique os logs para maiores detalhes.',
                tema: 'danger',
            });
        }
    }

    return (
        <LayoutDefault>
            <Cabecalho
                titulo="Alterar senha do usuário"
                descricao="Altere o formulário e clique em enviar para editar a senha do o usuário"
            />
            <Form onSubmit={ enviar } inicial={ data?.usuario } desabilitado={ isLoading } regras={ regras }>
                <div className="row">
                    <div className="col-md-4">
                        <div className="bg-white shadow-sm rounded p-4">
                            <div className="row">
                                <div className="col-md-12">
                                    <Campo
                                        type="password"
                                        name="senha"
                                        rotulo="Senha"
                                        prefixar={ <Icone nome="lock-fill" /> }
                                    />
                                </div>
                            </div>

                            <div className="mt-5">
                                <Botao>Enviar</Botao>
                                <BotaoLink tema="light" to={ `/usuarios/editar/${id}` } className="ms-2">
                                    Cancelar
                                </BotaoLink>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        </LayoutDefault>
    )
}

export default AlterarSenha;
